<h3>Roles</h3>
<hr />

<div class="btn-group ms-1 mt-2" role="group">
  <button type="button" class="btn btn-primary" (click)="selectAll()">Select All</button>
  <button type="button" class="btn btn-primary" (click)="selectNone()">Select None</button>
</div>

<input class="form-control my-4" type="text" placeholder="Search" [(ngModel)]="roleSearch" name="tile" />

<hr />
<ul class="list-group">
  <li *ngFor="let r of filteredRoles" class="list-group-item">
    <input
      class="form-check-input me-1"
      type="checkbox"
      [id]="'role-check-' + r.name"
      [checked]="isSelected(r.name)"
      (change)="toggleSelected(r.name)"
    />
    <label class="form-check-label stretched-link" [for]="'role-check-' + r.name">
      <span>{{ r.name }}</span>
    </label>
    <small class="d-block text-muted">{{r.description}}</small>
  </li>
</ul>
